module.exports = __webpack_public_path__ + "static/media/default_nearme.ce02eda0.svg";